import { Archive } from 'lucide-react';

interface SessionFiltersProps {
  selectedCenter: string | null;
  selectedPeriode: string | null;
  selectedSemaine: string | null;
  selectedStage: string | null;
  onCenterChange: (center: string | null) => void;
  onPeriodeChange: (periode: string | null) => void;
  onSemaineChange: (semaine: string | null) => void;
  onStageChange: (stage: string | null) => void;
  centers: { id: string; name: string }[];
  stages: { id: string; title: string }[];
  periodes: string[];
  showArchived: boolean;
  onShowArchivedChange: (show: boolean) => void;
  archivedCount: number;
}

const SessionFilters = ({
  selectedCenter,
  selectedPeriode,
  selectedSemaine,
  selectedStage,
  onCenterChange,
  onPeriodeChange,
  onSemaineChange,
  onStageChange,
  centers,
  stages,
  periodes,
  showArchived,
  onShowArchivedChange,
  archivedCount,
}: SessionFiltersProps) => {
  return (
    <div className="bg-white rounded-xl shadow-md p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold">Filtres</h2>
        <label className="flex items-center gap-2 cursor-pointer select-none group">
          <span className="flex items-center gap-1.5 text-sm text-gray-600 group-hover:text-gray-800 transition-colors">
            <Archive className="h-4 w-4" />
            Voir les sessions archivées
            {archivedCount > 0 && (
              <span className="inline-flex items-center justify-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-700">
                {archivedCount}
              </span>
            )}
          </span>
          <div
            onClick={() => onShowArchivedChange(!showArchived)}
            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200 ${
              showArchived ? 'bg-amber-500' : 'bg-gray-300'
            }`}
          >
            <span
              className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow-sm transition-transform duration-200 ${
                showArchived ? 'translate-x-4.5' : 'translate-x-0.5'
              }`}
            />
          </div>
        </label>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <label className="form-label">Centre</label>
          <select
            className="form-input"
            value={selectedCenter || ''}
            onChange={(e) => onCenterChange(e.target.value === '' ? null : e.target.value)}
          >
            <option value="">Tous les centres</option>
            {centers.map((center) => (
              <option key={center.id} value={center.id}>
                {center.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="form-label">Période</label>
          <select
            className="form-input"
            value={selectedPeriode || ''}
            onChange={(e) => onPeriodeChange(e.target.value === '' ? null : e.target.value)}
          >
            <option value="">Toutes les périodes</option>
            {periodes.map((periode) => (
              <option key={periode} value={periode}>
                {periode}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="form-label">Semaine</label>
          <select
            className="form-input"
            value={selectedSemaine || ''}
            onChange={(e) => onSemaineChange(e.target.value === '' ? null : e.target.value)}
          >
            <option value="">Toutes les semaines</option>
            {Array.from({ length: 7 }, (_, i) => `S${i + 1}`).map((semaine) => (
              <option key={semaine} value={semaine}>
                {semaine}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="form-label">Stage</label>
          <select
            className="form-input"
            value={selectedStage || ''}
            onChange={(e) => onStageChange(e.target.value === '' ? null : e.target.value)}
          >
            <option value="">Tous les stages</option>
            {stages.map((stage) => (
              <option key={stage.id} value={stage.id}>
                {stage.title}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SessionFilters;
